import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AnyType } from '@thehubz/shared/model';
import { AuthenticationLib } from '../util';

/**
 *  This class execute on event url change and prevent to open re-login component of app until user is logged in.
 *
 * @export
 * @class PreAuthenticationGuard
 * @implements {CanActivate}
 * @implements {CanActivateChild}
 */
@Injectable()
export class PreAuthenticationGuard {
  constructor(
    private authenticationLib: AuthenticationLib,
    private router: Router,
  ) {}

  canActivate(data?: AnyType): boolean {
    if (this.authenticationLib.isUserSessionActive()) {
      if (data?.['redirect']) {
        this.router.navigate([data['redirect']]);
      } else {
        this.router.navigate(['/assets']);
      }
      return false;
    } else {
      return true;
    }
  }
}

export const canActivatePreAuthentication: CanActivateFn = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
  return inject(PreAuthenticationGuard).canActivate(route.data);
};
